import { createFeatureSelector, createSelector } from '@ngrx/store';
import { Album } from '../../models/album.model';
import { AlbumState, albumAdapter } from '../reducers/album.reducer';
import { selectRouteParams } from './router.selector';

export const getAlbumState = createFeatureSelector<AlbumState>('albums');
export const getIds = (state: AlbumState) => state.ids;

export const {
  selectIds: getAlbumIds,
  selectEntities: getAlbumEntities,
  selectAll: getAllAlbums,
  selectTotal: getTotalAlbums,
} = albumAdapter.getSelectors(getAlbumState);

export const loading = createSelector(
  getAlbumState,
  (state: AlbumState) => state.loading,
);

export const inProgress = createSelector(
  getAlbumState,
  (state: AlbumState) => state.inProgress,
);

export const getAlbumsByGroupId = (groupId?: string) =>
  createSelector(getAllAlbums, selectRouteParams, (allItems, { id }) => {
    return groupId == undefined || groupId == null
      ? []
      : allItems
          .filter((item) => {
            return item.groupId === id && item.groupId === groupId;
          })
          .sort(sortDescendingByAlbumDate);
  });

export const getAlbumById = (albumId?: string) =>
  createSelector(getAllAlbums, (albums) =>
    albums.find((album) => album.id === albumId),
  );

function sortDescendingByAlbumDate(a: Album, b: Album): number {
  return a.albumDate! > b.albumDate! ? -1 : a.albumDate! < b.albumDate! ? 1 : 0;
}
